<template>
  <div class="m-category-box">
    <!--   <img src='../../assets/imgs/banner.png' style='width:96%;margin:0 auto;display:block;margin-top:20px;'> -->
    <div class='top'>
        <p>{{shopName}}</p>
        <img v-if="isHaidilao" src='../../assets/imgs/haidilaologo.png'>
        <img v-if="logo&&!isHaidilao" :src='previewImgUrl + logo'>
    </div>
    <!-- 轮播 20220112 -->
  <van-swipe v-if="images.length" :autoplay="3000" style='width:96%;margin:0 auto;display:block;margin-top:12px;text-align:center;overflow: hidden'>
      <van-swipe-item  v-for="(image, index) in images" :key="index">
       <img v-if="image.goodsCode" v-lazy="image.showAtiveUrl" :src="image.showAtiveUrl" @click="routerDetail(image.goodsCode)" style='width:96%;height:auto;margin-left: 50%;transform: translate(-50%, 0)' />
        <img v-if="!image.goodsCode" v-lazy="image.showAtiveUrl" :src="image.showAtiveUrl" style='width:96%;height:auto;margin-left: 50%;transform: translate(-50%, 0)' />
      </van-swipe-item>
    </van-swipe>
   <div v-if="!images.length" style='width:96%;margin:0 auto;display:block;margin-top:20px;text-align:center;overflow: hidden'>
      <img src="../../assets/imgs/banner.png" style='width:96%;height:100px;' />
    </div>
    <!-- end 轮播 20220112  -->
    <!-- 头部分类-->
    <div class="m-category-title">
      <div class="m-category-wrap st-navigation st-style" v-if="storeType != 'hcy'">
        <div class='st-navigation-wrap st-number0'>
          <!-- <div class='st-navigation-item' v-for='(item,index1) in navlists' :key='index1'>
            <img style='width:15px;float:left;' src='../../assets/imgs/yingxiang.png'>
            <span @click="change(item.id,index1)"
                  :class="activeLabel==item.id ? 'active' : '' ">
              {{item.name}}
              <i></i>
            </span>
          </div> -->
          <div class='quanbu'>
            <span>全部分类</span>
            <van-search v-model="queryKey" placeholder="请输入搜索内容" @search="onSearch"></van-search>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容区,根据选中展示样式的不同，选择不同的展示样式-->
    <div class="m-category-main">
      <div ref="left" v-if="styleTheme=='style-3'?false:true">
        <!-- 外层滚动容器：统一控制高度与滚动条，van-sidebar 内部不做滚动限制 -->
        <div class="m-category-nav-wrapper">
          <van-sidebar class="m-category-nav" v-model="activeKey" @change="changeCategory">
            <van-sidebar-item v-for="nav in categoryList" :key="nav.name" :title="nav.name" @click="selectCat" />
          </van-sidebar>
        </div>
      </div>
      <div :class="styleTheme=='style-3'?'m-category-content quan':'m-category-content'"  style="overflow:auto;" ref="right">
        <ul>
          <van-list v-model="page.loading" :finished="page.finished" finished-text="没有更多了"
            van-clearfix="m-category-content" @load="nextPage">
            <li class="right-item-hook">
              <!-- 111 -->
              <van-row gutter="8" :class="styleTheme=='style-1'?'bankuai':''">
                <van-col span="24" style="width: 100%;" v-if="navIndex == 0 && activeKey == 0 && storeType != 'hcy' && isDanBo "
                  class="gouwuche" @click.native="routerPhoto">
                  <van-image width='90px;' class="printIamge" :src="require('@/templates/imgs/product-photo.jpg')"
                    radius="4px" />
                  <div class="van-multi-ellipsis--l2" style="margin-left: 10px;">
                    <span class="gouwuce-tit" style='font-size:14px;text-align: left;'>照片冲印</span>
                    <p v-if="!isDanBo">冲洗不满意无条件退换货</p>
                    <van-tag v-if="isDanBo||tenantType=='2'"
                      :style="{'border-color':themeColor[1],'color':themeColor[1],}" class="category-by printtag">满29.9元包邮
                    </van-tag>
                    <!-- <p style='color:#FF672F;margin-top:50px;font-size:13px;'>￥0.5</p> -->
                   <!-- <div class='right-item-hookdivdiv'>
                      <span>￥0.5</span>
                    </div> -->
                  </div>
                </van-col>


                <van-col span="23" v-for="(item,index) in goodsList" :key="index" class="gouwuche">
                  <van-image width='90px' class="goods-img" :src="item.img" radius="4px" @click="routerDetail(item.id,item.cartType,item)" />
                  <div class="van-multi-ellipsis--l2 m-pro-title" @click="routerDetail(item.id,item.cartType,item)">
                    <span class="gouwuce-tit">{{item.name}}</span>
                    <p v-if="!isDanBo">{{item.spec}}</p>
                    <van-tag v-if="isDanBo||tenantType=='2'"
                      :style="{'border-color':themeColor[1],'color':themeColor[1]}" class="category-by">满29.9元包邮
                    </van-tag>
                    <!-- <div class='right-item-hookdivdiv'>
                      <span>￥{{item.realPrice}}</span>
                    </div> -->
                  </div>
                  <p>
                    <!-- <img v-if="!isDanBo" @click="routerDetailCar(item.id)" src="../../templates/imgs/cart.svg" /> -->
                  </p>
                </van-col>
              </van-row>
            </li>
          </van-list>
        </ul>
      </div>
    </div>
    <div class="m-icon-service" v-if="customerService&&customerService!='null'" @click="goCustomerService">
      <van-icon class-prefix="st-icon" name="servicel" />
      <br />
      客服
    </div>
  </div>
</template>


<script>
  import {
    mapGetters
  } from 'vuex';
  import GlobalEvent from '@/Event/GlobalEvent.js'
  import BScroll from 'better-scroll';
  import store from '@/store/index';
  import {
    Sidebar,
    SidebarItem,
    Divider,
    Image,
    Row,
    Col,
    Tab,
    Tabs,
    List,
    Toast,
    Swipe,
    SwipeItem,
    Tag,
    Search
  } from 'vant';
  import {
    doJsonPost,
    doFormPost,
    doJsonGet,
    doFormGet
  } from '@/utils/request';
  import {
    getTenantType,
    getCustomerService
  } from '@/utils/auth';

  export default {
    name: 'Category',
    components: {
      [Sidebar.name]: Sidebar,
      [SidebarItem.name]: SidebarItem,
      [Divider.name]: Divider,
      [Image.name]: Image,
      [Row.name]: Row,
      [Col.name]: Col,
      [Tab.name]: Tab,
      [List.name]: List,
      [Toast.name]: Toast,
      [Tabs.name]: Tabs,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Tag.name]: Tag
    },
    computed: {
      ...mapGetters([
        'theme',
        'storeType'
      ]),
      themeColor() {
        return this.theme.colors
      },
      themeFormat() {
        return this.theme.format
      }
    },
    data() {
      return {
        previewImgUrl:'http://epmall.test.36588.com.cn/admin-api-test/pageTemplate/pageReviewImg.do?filePath=',
        orderId: this.$route.params.orderId? this.$route.params.orderId: this.$route.query.orderId,
        orderPrice: this.$route.params.orderPrice? this.$route.params.orderPrice: Number(this.$route.query.orderPrice),
        checked: true,
        listHeight: [],
        scrollY: 0,
        clickEvent: false,
        //标题
        activeLabel: '',
        // 分类
        activeKey: 0,
        activeCategoryCode: '',
        navlists: [],
        categoryList: [],
        goodsList: [],
        queryKey: '', //搜索关键词
        page: {
          loading: true,
          finished: false,
          pageNum: 1,
          pageSize: 12,
          total: 0,
          pageFrom: "1"
        },
        pros:[],//收藏商品
        //内容
        itemLists: [],
        routerParam: {
          categoryId: this.$route.params.categoryId,
          labelId: this.$route.params.labelId
        },
        navIndex: 0,
        catIndex: 0,
        tenantType: "",
        isDanBo: this.$store.state.app.isDanBo,
        isHaidilao: this.$store.state.app.isHaidilao,
        styleTheme: '',
        shopName:this.$store.state.app.shopName,
        logo:this.$store.state.app.logo,
        allgoods:"",//showgoods表中查出的所有产品数据
        customerService: false,
        bannerUrl:'../../assets/imgs/banner.png',
        images: [],
        iszhengjian:false,
      }
    },
    methods: {
      /**
       * 查询收藏商品列表
       */
      queryMySelfCollect() {
          let that = this;
          doFormPost('/goods//queryGoodsInFav', this.page, rs =>{
              if (rs.result === 'success') {
                  that.page.total = rs.userData.favCount;
                  if (that.page.total === 0) {
                      that.page.finished = true;
                  } else {
                      var totalPageNum = parseInt(that.page.total / that.page.pageSize);
                      if (that.page.total / that.page.pageSize > totalPageNum) {
                          totalPageNum += 1;
                      }
                      if (that.page.pageNum >= totalPageNum) {
                          that.page.finished = true;
                      }
                      if (rs.userData.favList.length === 0) {
                          that.page.finished = true;
                      } else {
                        if(that.categoryList[0].id=="0"){

                        }else{
                          var category ={
                            id:"0",
                            name:"收藏商品",
                          };
                          that.categoryList.unshift(category);

                        }
                        that.goodsList=[];
                          if (that.goodsList.length > 0) {
                              rs.userData.favList.forEach(item => {
                                var goods={
                                      id:that.allgoods[a].goodsCode,
                                      name:that.allgoods[a].showGoodsName,
                                      img:that.allgoods[a].previewUrl,
                                      spec:that.allgoods[a].showSpecs,
                                      cartType:that.allgoods[a].cartType,
                                      goodsType:that.allgoods[a].goodsType
                                    }
                                    goodsList.push(goods)
                              })
                              that.goodsList.push(goodsList);
                          } else {
                            var goodsList =[];
                            rs.userData.favList.forEach(item => {
                              for(let a=0;a<that.allgoods.length;a++){
                                if(that.allgoods[a].goodsCode==item.goodsId){
                                   var goods={
                                  	id:that.allgoods[a].goodsCode,
                                  	name:that.allgoods[a].showGoodsName,
                                  	img:that.allgoods[a].previewUrl,
                                  	spec:that.allgoods[a].showSpecs,
                                    cartType:that.allgoods[a].cartType,
                                    goodsType:that.allgoods[a].goodsType
                                    }
                                    goodsList.push(goods)
                                }
                              }

                            })
                             this.goodsList=goodsList;
                              // that.pros = rs.userData.favList;
                          }
                      }
                  }
                  that.page.loading = false;
              } else {
                  Toast(rs.message);
              }
          })
      },
      onSearch() {
        if(this.isDanBo){
          return;
        }
        console.info("this.queryKey")
        console.info(this.queryKey)
        this.queryShowGoods(this.queryKey);
      },
      goCustomerService() {
        window.location.href = this.customerService;
      },
      routerList() {
        this.$router.push({
          name: 'list',
        })
      },
      routerDetail(goodsId,cartType,item) {
        this.sendRecord('click_on_the_category_page_goods', {
          goodsId: goodsId,
          desc: '商品ID'
        })
        // var cartType='';
        // for(let i=0;i<this.goodsList.length;i++){
        //   if(this.goodsList[i].id == goodsId){
        //     cartType = this.goodsList[i].cartType;
        //     break;
        //   }
        // }
        //暂时使用名称判断，后期添加字段判断
        if(item.name&&item.name.indexOf("证件照")!=-1){
          this.iszhengjian = true;
        }
        this.$router.push({
          name: 'detail',
          params: {
            goodsId: goodsId,
            labelCode: item.goodsType,
            cartType:cartType,
            specName:item.spec,
            isPhoto:this.iszhengjian
          }
        })
        // this.$router.push({
        //     name: 'cloudDetail',
        //     params: {
        //         goodsId: goodsId
        //     }
        // })
      },
      routerDetailCar(goodsId) {
        this.$router.push({
          name: 'detail',
          params: {
            goodsId: goodsId,
            goodsList: 'goodsList',
            labelCode: this.activeLabel,
          }
        })
        // this.$router.push({
        //     name: 'cloudDetail',
        //     params: {
        //         goodsId: goodsId
        //     }
        // })
      },
      routerPhoto() {
        this.$router.push({
          name: 'photo'
        })
      },
      //头部切换选中样式
      change(code, index) {
        this.activeLabel = code;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.goodsList = [];
        this.page.finished = false;
        this.page.loading = true;
        this.navIndex = index;
        this.queryCategory();
        this.sendRecord('click_on_category_search', {
          code: code
        })
      },
      changeCategory(index) {
        this.activeKey = index;
        this.activeCategoryCode = this.categoryList[index].id;
        this.page.pageNum = 1;
        this.page.total = 0;

        this.page.finished = false;
        //搜索全部商品
        if(this.activeCategoryCode=="00"){

          this.goodsList = [];
          this.$router.push({
            name: 'showOuerDetail',
          })
          return;
        }
        if(this.activeCategoryCode=="-1"){
          return;
        }
         this.goodsList = [];
        if(this.activeCategoryCode=="0"){
         this.queryMySelfCollect();
        }else{
          // this.page.loading = true;
          if(this.allgoods.length>0){
            for(let a=0;a<this.allgoods.length;a++){
              if(this.activeCategoryCode==this.allgoods[a].categoryCode){
                var goods={
                  id:this.allgoods[a].goodsCode,
                  name:this.allgoods[a].showGoodsName,
                  img:this.allgoods[a].previewUrl,
                  spec:this.allgoods[a].showSpecs,
                  cartType:this.allgoods[a].cartType,
                  goodsType:this.allgoods[a].goodsType
                }
                this.goodsList.push(goods)
              }
            }
          }

        }
        // this.queryGoodsData();
      },
      //获取包邮金额
      queryfree() {
        doFormPost('', rs => {

        })
      },
      queryLabel() {
        var that = this;
        doFormPost('/goods/queryLabelList', {
          pageFrom: '1'
        }, rs => {
          if (rs.result === 'success') {

            // if(that.isDanBo&&rs.userData.length>0){
            //   rs.userData.forEach(lab =>{
            //     if(lab.id!="04"){//蛋啵产品不要印刷
            //       that.navlists.push(lab);
            //     }
            //   })
            // }else{

            // }
            if (that.isDanBo) {
              // that.navlists = [];
              // var item= {
              //   id:'02',
              //   name: "冲印",
              //   pageNum: 1,
              //   pageOffset: 0,
              //   pageSize: 20,
              //   sort: 1,
              // };
              //  that.navlists.push(item);
              var item1 = {
                id: '03',
                name: "影像",
                pageNum: 1,
                pageOffset: 0,
                pageSize: 20,
                sort: 1,
              };
              that.navlists.push(item1);
              that.navIndex = '0';
              that.activeLabel = that.navlists[0].id;
            } else {
              that.navlists = rs.userData;
              if (that.routerParam.labelId !== null && that.routerParam.labelId !== '' && that.routerParam
                .labelId !== undefined) {
                that.activeLabel = that.routerParam.labelId;
                that.routerParam.labelId = '';
                that.navlists.forEach((nav, index) => {
                  if (that.activeLabel == nav.id) {
                    that.navIndex = index
                  }
                })
              } else {
                that.activeLabel = that.navlists[0].id;
              }
            }

            that.queryCategory();
          } else {
            Toast(rs.message);
          }
        })
      },
      queryCategory() {
        var that = this;
        return
        doFormPost('/goods/queryGoodsCategory', {
          labelCode: this.activeLabel,
          pageFrom: '1'
        }, rs => {
          if (rs.result === 'success') {
            if (that.isDanBo && this.activeLabel == "02") { //冲印
              that.categoryList = [];
              that.page.loading = false;
              return
            }
            that.categoryList = rs.userData;
            if (that.categoryList !== null && that.categoryList.length > 0) {
              if (that.routerParam.categoryId !== null && that.routerParam.categoryId !== '' && that.routerParam
                .categoryId !== undefined) {
                that.activeCategoryCode = that.routerParam.categoryId;
                that.categoryList.forEach((item, index) => {
                  if (item.id === that.routerParam.categoryId) {
                    that.activeKey = index;
                    return false;
                  }
                })
                that.routerParam.categoryId = '';
              } else {
                that.activeCategoryCode = that.categoryList[0].id;
                that.activeKey = 0;
              }

              that.queryGoodsData();
            } else {
              that.page.finished = true;
            }

          } else {
            Toast(rs.message);
          }
        })
      },
      queryShowGoods(queryString){
        var that = this;
        var param = {};
        param.shopId =this.$store.state.app.shopId;
        param.queryString =queryString;
        that.categoryList=[];
        that.goodsList=[];
        doFormPost('/goods/queryshowGoodsList', param, rs => {
          console.info("queryshowGoodsList")
           console.info(rs)
          if (rs.result === 'success') {
            //将所有的商品按分类code分开
            var data = new Array;
            if(this.isHaidilao){
              if(rs.userData&&rs.userData.length>0){
                for(let tt=0 ;tt< rs.userData.length;tt++) {
                  // if(rs.userData[tt].isDelete&&rs.userData[tt].isDelete==='0'){
                  //     data.push(rs.userData[tt])
                  // }else{
                    if(rs.userData[tt].cartType){
                      data.push(rs.userData[tt])
                    }
                  // }

                }
              }
            }else{
              data = rs.userData;
            }
            that.allgoods = data;
            //修改查询展示
            if(queryString&&queryString!=''){
              that.activeCategoryCode="";
              var category ={
                id:"-1",
                name:"全部商品",
              };
               that.categoryList.push(category);
               var goodsList=[];
               for(let c=0;c<data.length;c++){
                   var goods={
                     id:data[c].goodsCode,
                     name:data[c].showGoodsName,
                     img:data[c].previewUrl,
                     spec:data[c].showSpecs,
                     cartType:data[c].cartType,
                     goodsType:data[c].goodsType
                   }
                   goodsList.push(goods)
               }
               that.goodsList = goodsList;
            }else{
              const set = new Set();
              if(data.length>0){
                    for(let a=0;a<data.length;a++){
                      set.add(data[a].categoryCode)
                    }
                  console.info("queryshowGoodsList==set==")
                 console.info(set)
                 //处理分类显示
                 var categoryList =[];
                 for(let code of set){
                   for(let i=0;i<data.length;i++){
                     if(data[i].categoryCode==code){
                       var category ={
                         id:data[i].categoryCode,
                         name:data[i].showCategoryName,
                       };
                       categoryList.push(category);
                       break;
                     }
                   }
                 }
                //添加关于我们页签
                if(this.$store.state.app.brandConfig.isYh){
                  var categoryde ={
                    id:"00",
                    name:"关于我们",
                  };
                categoryList.push(categoryde);
                }
                 that.categoryList=categoryList;
                 //处理商品  goodsList
                 var goodsList =[];
                 var firstcategory = categoryList[0];
                for(let c=0;c<data.length;c++){
                  if(data[c].categoryCode == firstcategory.id){
                    var goods={
                      id:data[c].goodsCode,
                      name:data[c].showGoodsName,
                      img:data[c].previewUrl,
                      spec:data[c].showSpecs,
                      cartType:data[c].cartType,
                      goodsType:data[c].goodsType
                    }
                    goodsList.push(goods)
                  }
                }
                that.goodsList = goodsList;
                that.queryMySelfCollect();
              }
            }
          that.page.loading = false;
          } else {
            Toast(rs.message);
          }
        })
      },
      //添加华莱士和保险公司人员权限校验
      hualaishiUserCheck() {
        var that = this;

        var url="";
        if(localStorage.getItem("account")){
          url = '/wechatLogin/checkHuaLaiShiUser' + '?serverNum='+localStorage.getItem("account")
        }else{
           url = '/wechatLogin/checkHuaLaiShiUser'
        }
          doJsonPost(url, null, rs => {

              console.info(rs)
              if (rs.result == 'success') {
                if(rs.userData && rs.userData.usrUser){
                  if(rs.userData.hualaishiUser==null){
                  }else{
                    if(rs.userData.hualaishiUser){
                    var hua = rs.userData.hualaishiUser;
                    localStorage.setItem("maxNum", hua.maxNum)
                    localStorage.setItem("areadyNum", hua.areadyNum)
                    localStorage.setItem("phone", hua.phone)
                    localStorage.setItem("userName", hua.name)
                    localStorage.setItem("hualaishiCode", hua.shopCode)
                    store.dispatch('setUserName', hua.name);
                    store.dispatch('setChildShopName', hua.childShopName);
                    store.dispatch('setChildShopCode', hua.childShopCode);
                    // GlobalEvent.create('screenShot').trigger('toDataURLComplete',hua.childShopName);
                     // store.dispatch('setUserName', hua.name);
                     // store.dispatch('setPhone', hua.phone);
                     // store.dispatch('setMaxNum', hua.maxNum);
                     // store.dispatch('setAreadyNum', hua.areadyNum);
                    }
                     store.dispatch('setOpenId', rs.userData.usrUser.wxOpenid);
                  }
                }else{
                  //海底捞兼容邮箱登录
                  if(rs.userData&&that.$store.state.app.brandConfig.isHaidilao){
                    var data = rs.userData;
                    store.dispatch('setChildShopName', data.name);
                    store.dispatch('setChildShopCode', data.code);
                    localStorage.setItem("hualaishiCode", data.code)
                    that.shopName = data.name;
                    // GlobalEvent.create('screenShot').trigger('toDataURLComplete',data.name);
                  }else{
                   that.showtips = true;
                  }
                }
              }else{
                that.showtips = true;
              }
          })
      },
      queryShowActive(){
        var that = this;
        var param = {};
        param.shopId =this.$store.state.app.shopId;
        that.images=[];
        doFormPost('/goods/queryshowActiveList', param, rs => {
          console.info("active===")
          console.info(rs)
          if (rs.result === 'success') {
            that.images=rs.userData;
          }
        })
      },
      queryGoodsData() {
        var that = this;
        that.page.loading = false;
        return;
        this.page.category = this.activeCategoryCode;
        doFormPost('/goods/queryGoodsList', this.page, rs => {
          if (rs.result === 'success') {
            that.page.total = rs.userData.goodsCount;
            if (that.page.total === 0) {
              that.page.finished = true;
            } else {
              var totalPageNum = parseInt(that.page.total / that.page.pageSize);
              if (that.page.total / that.page.pageSize > totalPageNum) {
                totalPageNum += 1;
              }
              if (that.page.pageNum >= totalPageNum) {
                that.page.finished = true;
              }
              if (rs.userData.goodsList.length === 0) {
                that.page.finished = true;
              } else {
                if (that.goodsList.length > 0) {
                  rs.userData.goodsList.forEach(item => {
                    that.goodsList.push(item);
                  })
                } else {
                  that.goodsList = rs.userData.goodsList;
                }
              }
            }

            that.page.loading = false;
          } else {
            Toast(rs.message);
          }
        })
      },
      nextPage() {
        this.page.pageNum = this.page.pageNum + 1;
        this.queryGoodsData();
      },
      showOurDetail(){
        console.info("111111111")
      },
      selectCat(index) {
        this.catIndex = index
      },
      screenShotComplete(childShopName) {
         console.info("childShopName====");
        console.info(childShopName);
        this.shopName = childShopName;
      },
      //初始化产品列表配置数据
       getStyle() {
         var that = this;
           doJsonPost('/main/getStyle', null, rs => {
             console.info("getStyle====")
               console.info(rs)
               if (rs.result === 'success') {

                 if(rs.userData.shopStyle){
                   that.$store.dispatch('setStyleTheme', rs.userData.shopStyle);
                   that.styleTheme = rs.userData.shopStyle;
                 }else{
                   that.$store.dispatch('setStyleTheme', 'style-1');
                   that.styleTheme = "style-1";
                 }

               }else{
                  that.$store.dispatch('setStyleTheme', 'style-1');
                  that.styleTheme = "style-1";
               }
           })
       },
    },
    mounted() {

    },

    created(query) {
      if (this.orderId&&this.orderPrice) {
          this.$router.push({
            name: 'order-success',
            params: {
              orderId: this.orderId,
              orderPrice: Number(this.orderPrice),
            }
          })
      }
      if(this.isHaidilao){
        if(!this.$store.state.app.childShopName){
           GlobalEvent.create('screenShot').listen('toDataURLComplete', this.screenShotComplete);
        }else{
           this.shopName = this.$store.state.app.childShopName;
        }
      }
      this.getStyle();
      if(localStorage.getItem("account")){
        this.hualaishiUserCheck();
      }
      this.customerService = getCustomerService();
      GlobalEvent.create('showNavbar').trigger('Navbar',true);
      // doFormPost('/homePage/test',{platform:'IntelliStore'}, rs=> {
      this.queryLabel();
      // });
      this.sendPV({
        path: '商品分类页'
      });
      this.tenantType = getTenantType();
      if(!this.isDanBo){
        this.queryShowGoods();
        this.queryShowActive();
      }else{
        var category ={
          id:"0",
          name:"全部分类",
        };
        this.categoryList.push(category)
        this.page.loading = false;
      }

    console.info(this.logo)
    },
    beforeDestroy() {
    		GlobalEvent.create('screenShot').remove('toDataURLComplete', this.screenShotComplete);
    }
  }
</script>

<style scoped>
  .st-navigation {
    position: relative;
    overflow: hidden;
  }
  .m-category-main>div:first-child{
    background:#F7F8FA;
  }
  .st-navigation-dec {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: repeat-y;
  }

  .st-navigation-wrap {
    display: flex;
    flex-wrap: wrap;
    padding: 0px 4px;
    position: relative;
    z-index: 1;
  }

  .st-navigation-item {
    display: block;
    text-align: center;
    font-size: 12px;
    width: 25%;
    color: #434a54;
    box-sizing: border-box;
    background: linear-gradient(134deg, #F5F1FD 0%, #E3DDFF 100%);
    overflow: hidden;
    padding: 10px;
    margin: 0 10px;
    border-radius: 5px;
  }

  .st-navigation-item span {
    border-radius: 24px;
    padding: 6px 10px;
    color: #606266;
  }

  .st-navigation-item span.active {
    color: #6a67d0;
    font-weight: bold;
    background: transparent;

  }

  .st-navigation-item .st-img {
    display: inline-block;
    width: 56px;
    margin-bottom: 4px;
  }

  .st-navigation-item .st-img>div {
    padding: 50% 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .st-navigation.st-style0 .st-navigation-wrap {
    background: #fff;
  }

  .st-navigation.st-style1 .st-navigation-item {
    color: #fff;
  }

  .st-navigation.st-style2 .st-navigation-dec {
    bottom: auto;
    height: 70%;
    border-radius: 0 0 20% 20%;
  }

  .st-navigation.st-style2 .st-navigation-wrap {
    background: #fff;
    padding: 12px 0 4px;
    margin: 12px;
    border-radius: 5px;
  }

  .st-navigation-wrap.st-number0 {
    display: block;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    text-align: left;
  }

  .st-navigation-wrap.st-number0::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .st-navigation-wrap.st-number0 .st-navigation-item {
    display: inline-block;
    width: auto;
  }

  .st-navigation-wrap.st-number5 .st-navigation-item {
    width: 20%;
  }

  .st-navigation-wrap.st-number5 .st-navigation-item .st-img {
    width: 52px;
  }

  .st-navigation-item .active {
    color: #ff0036;
  }

  .m-category-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    /* 底部预留 tabbar 高度（50px + 10px），整页不进入 tabbar 区域 */
    bottom: 60px;
    background-color: #F5F9FC;
    width: 100%;
    overflow: hidden;
    /* 纵向 flex：顶部区域自适应实际高度，内容区占满剩余空间 */
    display: flex;
    flex-direction: column;
  }
  /* iPhone 全面屏：叠加底部安全区 */
  @supports (bottom: env(safe-area-inset-bottom)) {
    .m-category-box {
      bottom: calc(60px + env(safe-area-inset-bottom));
    }
  }

  .m-category-title {
    text-align: center;
    padding-top: 6px;
  }

  .m-category-wrap {
    width: 100%;
    overflow: hidden;
  }

  .m-category-item {
    display: inline-block;
    padding-left: 18px;
    padding-right: 18px;
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    color: #656D78;
    vertical-align: middle;
    border-radius: 30px;
    padding: 0;
    width: 25%;
  }

  .m-category-item.active {
    color: #ff0036;
  }

  .m-category-main {
    /* 占满页面容器剩余高度（顶部区域高度变化时自动适配） */
    flex: 1;
    min-height: 0;
    border-top: 1px solid #ebeef5;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
  }

  .m-category-content {
    background: #fff;
  }

  .m-category-content {
    /* float: left; */
    /* 高度由 flex 拉伸决定 */
    overflow-y: auto;
    border-right: 1px solid #ebeef5;
  }

  /* 左侧分类导航：外层滚动容器统一控制高度与滚动条（van-sidebar 内部不做滚动限制） */
  .m-category-nav-wrapper {
    /* 跟随 flex 拉伸占满剩余高度，顶部高度变化时自动适配 */
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; /* iOS 惯性滚动 */
    border-right: 1px solid #ebeef5;
    scrollbar-width: thin; /* Firefox 降级方案 */
    scrollbar-color: #c8c9cc transparent;
  }
  .m-category-nav-wrapper::-webkit-scrollbar {
    width: 4px;
  }
  .m-category-nav-wrapper::-webkit-scrollbar-thumb {
    background: #c8c9cc;
    border-radius: 2px;
  }
  .m-category-nav-wrapper::-webkit-scrollbar-track {
    background: transparent;
  }

  .m-category-nav>>>.van-sidebar-item {
    color: #434A54;
    font-size: 12px;
  }

  .m-category-nav>>>.van-sidebar-item__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  .m-category-content {
    width: calc(100% - 80px);
    padding: 8px 12px;
    box-sizing: border-box;
    overflow: hidden;
    float: left;
  }

  .right-item-hook {
    /* border-bottom: 1px solid #ddd; */
    padding-bottom: 10px;
  }

  .right-item-hook .m-pro-title {
    font-size: 10px;
    color: #656D78;
    min-height: 32px;
    display: block;
    margin: 0;
    margin-left: 20px;
  }

  .right-item-hookdivdiv {
    position: absolute;
    bottom: 10px;
  }

  .m-category-nav>>>.van-sidebar-item {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #666;
    padding: 12px 4px;
    background: none;
  }

  .m-category-nav>>>.van-sidebar-item--select {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #000;
    background:#fff;
  }

  .van-sidebar-item--select::before {
    opacity: 0;
  }

  .m-category-content>>>.van-divider {
    color: #434A54;
    font-size: 12px;
  }

  .m-category-content>>>.van-divider::after,
  .m-category-content>>>.van-divider::before {
    color: #CCD1D9;
    transform: unset !important;
  }

  .m-category-content>>>.van-divider::after {
    margin-right: 50px;
  }

  .m-category-content>>>.van-divider::before {
    margin-left: 50px;
  }

  .right-item-hook {
    overflow: hidden;
  }

  .right-item-hook .van-image {
    width: 30%;
    float: left;
  }

  .van-multi-ellipsis--l2 {
    float: left;
    width: calc(100% - 112px);
    margin-left: 110px;
  }

  .right-item-hook .gouwuce-tit {
    font-weight: 500;
    font-size: 14px;
    /* -webkit-box-orient:vertical;
    -webkit-line-clamp:2; */
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .right-item-hook div p {
    color: #909399;
    /* display:-webkit-box;
	-webkit-box-orient:vertical;
	-webkit-line-clamp:2;
	overflow:hidden; */
    margin: 0;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-top:10px;
  }

  .right-item-hook div div div div span {
    color: #ff0036;
    font-size: 13px;
  }

  .right-item-hook div div div div img {
    margin: 0 auto;
    width: 20px;
    display: block;
    margin-top: 5px;
  }

  .right-item-hook div div div div p {
    width: 30px;
    height: 30px;
    background: #eee;
    border-radius: 50%;
    float: right;
    margin-top: -5px;
  }

  .van-swipe {
    overflow: initial;
  }

  .van-swipe i {
    width: 100%;
    display: block;
    height: 2px;
    background: #BD0611;
    margin-top: 5px;
    display: none;
  }

  .m-category-item.active i {
    display: block;
  }

  .gouwuche {
    position: relative;
    border-bottom: 1px solid #ebeef5;
    padding: 8px 0;
    margin: 4px 0;
    height: 112px;
    box-sizing: border-box;
    width: 100%;
  }

  .right-item-hook div p img {
    width: 20px;
  }

  .gouwuche>p {
    position: absolute;
    right: 0;
    bottom: 4px;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .m-detail-category {
    border-radius: 16px;
    color: rgb(255, 0, 54);
  }

  .category-by {
    font-size: 10px;
    background: #fff;
    border: 1px solid;
    margin-top: 8px;
  }

  .m-icon-service {
    background: #fff;
    width: 44px;
    height: 44px;
    box-shadow: 0 3px 6px #dcdfe6;
    color: #606266;
    font-size: 10px;
    padding: 4px;
    box-sizing: border-box;
    bottom: 80px;
  }

  .m-icon-service .st-icon-servicel {
    font-size: 20px;
  }
  .top{
    overflow:hidden;
    background: linear-gradient(180deg, rgba(251,60,4,0.12) 0%, #FFFFFF 100%);
    padding:20px;
  }
  .top p{
    float:left;
    font-size:25px;
    font-weight:600;
    margin:0;
  }
  .top p::after{
    content:"";
    display:block;
    width:41px;
    background:#FE624C;
    height:3px;
    margin-top:10px;
  }
  .top img{
    width:40px;
    height:40px;
    float:right;
    border-radius:5px;
  }
  .quanbu{
    overflow:hidden;
    background:#fff;
  }
  .quanbu>span{
    float:left;
    width:80px;
    line-height:50px;
    text-align:center;
  }
  .bankuai{
    overflow:hidden;
  }
  .bankuai>div{
    width:50%;
    float:left;
    padding:10px;
    box-sizing: border-box;
  }
  .bankuai .van-image{
    width: 49%;
    margin: 0 auto;
    display: flex;
    height: 90px;
    justify-content: center;
    align-items: center;
  }
  /* 深度选择器覆盖vant原本样式 */
  .goods-img >>> .van-image__img{
    display: block;
    width: auto !important;
    height: auto !important;
    max-width: 100% !important;
    max-height: 100% !important;
  }
  .bankuai .m-pro-title {
    width: 100%;
    float: none;
    margin-left: 0;
    height: 52px;
  }
  .bankuai .gouwuche {
      height: auto;
      display: flex;
      flex-direction: column;
  }
  .bankuai .gouwuce-tit{
    margin-top:10px;
    text-align:center;
    margin-left:0;
  }
  .bankuai div p{
    text-align:center;
  }
  .m-category-main>.quan:first-child{
    width:100%;
    background:#fff;
  }
  .quan .van-image{
    width:100% !important;
  }
  .quan .gouwuche{
    height:initial;
    border:none;
  }
  .quan .m-pro-title{
    margin-left:0;
    margin-top:10px;
  }
  .printIamge{
    float: left !important;
    width: 90px !important;
  }
  .printtag{
    margin-top: 43px !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/goods/category.vue